<template>
    <div class="peribox">
        <div class="perititle">
            <div>Driver</div>
            <div class="periicons">
                <i class="far fa-sync-alt" @click="refresh"></i>
            </div>
        </div>

        <table class="peritable" v-loading="loading">
            <tbody>
            <tr>
                <th>Column</th>
                <th>Record</th>
            </tr>
            <tr v-for="c in columns">
                <th>{{ c }}</th>
                <td>{{ row ? row[c] : '' }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: [
        'driver_id'
    ],
    data() {
        let columns = [
            'id',
            'name',
            'first_name',
            'middle_name',
            'last_name',
            'email_redacted',
            'email_id',
            'phone_redacted',
            'phone_id',
            'zip_code',
            'timezone',
            'cdl_a',
            'cdl_b',
            'cdl_c',
            'cdl_a_months_driven',
            'cdl_xp',
            'cdl_xp_text',
            'created_at',
            'updated_at',
            'city',
            'state_code',
            'location',
            'sms_optin',
            'deja_optout',
            'deja_optout_at',
            'dont_sms_until',
            'marketing_dont_call_until',
            'inbound_hunt_until',
            'paid_media_source',
            'tr_phone',
            'company_drivers',
            'owner_operators',
            'lease_purchase',
            'otr',
            'regional',
            'dedicated',
            'local',
            'dry_van',
            'flatbed',
            'refrigerated',
            'tanker',
            'auto_hauler',
            'intermodal',
            'ltl',
            'specialized',
            'team',
            'solo',
            'oilfield',
            'twic',
            'hazmat',
            'note'
        ];
        return {
            row: null,
            columns: columns,
            loading: true
        };
    },
    methods: {
        refresh() {
            this.loading = true;
            axios.get(url(`driver/test/driver/${this.driver_id}`))
                .then((response) => {
                    this.row = response.data.row;
                    this.loading = false;
                });
        }
    },
    mounted() {
        this.refresh();
    }
}
</script>

<style>
</style>